import type { getBuyerAuthContext } from '@/app/_shared/lib/api/shared/buyers';
import type { getSellerAuthContext } from '@/app/_shared/lib/api/shared/sellers';
import { createContext, useContext } from 'react';

export type BuyerAuthContext = NonNullable<Awaited<ReturnType<typeof getBuyerAuthContext>>>;
export type SellerAuthContext = NonNullable<Awaited<ReturnType<typeof getSellerAuthContext>>>;

export interface UserData {
    name: string;
    id: string | null;
    user: BuyerAuthContext | SellerAuthContext | null;
    isAdmin: boolean;
    isSeller: boolean;
    isBuyer: boolean;
    isAnonymous: boolean;
    isReadOnly: boolean;
    loading: boolean;
}

export const ANONYMOUS_ID = '0000-0000-0000-0000';

export const UserDataContext = createContext<UserData>({
    name: '',
    id: ANONYMOUS_ID,
    user: null,
    isAdmin: false,
    isSeller: false,
    isBuyer: false,
    isAnonymous: false,
    isReadOnly: true,
    loading: true,
});

export const useUserData = () => useContext(UserDataContext);
